import { render } from "./FilterItem.vue?vue&type=template&id=5de70a04&bindings={}"
import script from "./FilterItem.vue?vue&type=script&lang=ts"
export * from "./FilterItem.vue?vue&type=script&lang=ts"

import "./FilterItem.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script